import lodash from 'lodash'
import store from '@/store'
import i18n from '@/utils/i18n'
import { eCircularRouteNames, directoryRouteNames, FEATURE_NAMES } from '@/utils/consts'
import { aclHelper, tenantPermsTypes, ccdPermsTypes, tmsPermsTypes } from '@/utils/aclHelper'
import { ExportContactsRouteNames } from '@/constants/router'

const getFeatureStatus = () => store.getters['regions/featureStatus']
const filterMenu = (menu) => {
  const result = menu.filter(filterByEnable).filter(filterByPermissions)
  return result
}

const filterByEnable = (item) => {
  const enable = lodash.get(item, 'enable', true)
  if (enable instanceof Function) {
    return enable()
  }
  return enable
}

const filterByPermissions = (item) => {
  if (item.permType instanceof Function) {
    return item.permType()
  }
  if (item.permType) {
    return aclHelper.getAccess(item.permType)
  }
  return true
}

export default {
  engineerMenu () {
    const featureStatus = getFeatureStatus()

    const eCircularType = aclHelper.hasTenantEcircularRead() && (featureStatus[FEATURE_NAMES.TENANT_PROJECTS] || featureStatus[FEATURE_NAMES.TENANCY_RECORDS]) ? 'tenant' : 'vendor'

    const menu = [
      { title: i18n.t('hamburgerMenu.tenders'), target: 'tenders', permType: aclHelper.hasTendersAccess, enable: featureStatus[FEATURE_NAMES.TENDERS] },
      { title: i18n.t('hamburgerMenu.projects'), target: 'projects', permType: aclHelper.hasProjectsAccess, enable: featureStatus[FEATURE_NAMES.HONGKONG_LAND_PROJECTS] },
      { title: i18n.t('hamburgerMenu.tenancyRecords'), target: 'allTenancyRecs', permType: ccdPermsTypes.tenancy.read, enable: featureStatus[FEATURE_NAMES.TENANCY_RECORDS] },
      { title: i18n.t('hamburgerMenu.tenantProjects'), target: 'allTenantProjects', permType: aclHelper.hasTenantProjectsAccess, enable: featureStatus[FEATURE_NAMES.TENANT_PROJECTS] },
      { title: i18n.t('hamburgerMenu.workPermits'), target: 'allWorkPermits', permType: tmsPermsTypes.workpermit.read, enable: featureStatus[FEATURE_NAMES.WORK_PERMITS] },
      { title: i18n.t('tenancy.contacts'), target: 'contacts', permType: aclHelper.hasContactsAccess },
      { title: i18n.t('hamburgerMenu.exportContacts'), target: ExportContactsRouteNames.exportContacts, permType: aclHelper.showExportContacts, enable: this.showExportContactsByFeature },
      { title: i18n.t('performance.title'), target: 'performance', permType: aclHelper.hasPerformanceAccess, enable: featureStatus[FEATURE_NAMES.VENDOR_PERFORMANCE] },
      { title: i18n.t('eCircular.name'), target: eCircularRouteNames.eCircularHistory, params: { type: eCircularType }, permType: aclHelper.hasEcircularRead, enable: featureStatus[FEATURE_NAMES.E_CIRCULAR] },
      { title: i18n.t('settings.title'), target: 'settings', permType: aclHelper.hasSettingsAccess },
      { title: i18n.t('hamburgerMenu.maintainDirectory'), target: 'directoryOrder', permType: aclHelper.hasMaintainAccess, enable: featureStatus[FEATURE_NAMES.DIRECTORY] },
      { title: i18n.t('hamburgerMenu.maintainDirectoryArchived'), target: directoryRouteNames.directoryArchived, permType: tmsPermsTypes.directory.read, enable: featureStatus[FEATURE_NAMES.DIRECTORY] },
      { title: i18n.t('hamburgerMenu.userGuideAndForms'), target: 'userGuideForms' },
    ]

    return filterMenu(menu)
  },
  commonMenusForExternal () {
    return [{ title: i18n.t('hamburgerMenu.userGuideAndForms'), target: 'userGuideForms' }]
  },
  tenantMenu ({ hasTenancyRecords = false } = {}) {
    const featureStatus = getFeatureStatus()
    let menu = []
    menu.push({
      title: i18n.t('hamburgerMenu.tenancyRecords'),
      target: 'tenantAllTenancyRecs',
      permType: () => hasTenancyRecords && aclHelper.getAccess(tenantPermsTypes.tenancies.readUpdate),
      enable: featureStatus[FEATURE_NAMES.TENANCY_RECORDS],
    })
    menu.push(...this.commonMenusForExternal())
    return filterMenu(menu)
  },
  contractorMenu () {
    let menu = []
    menu.push({ title: i18n.t('settings.title'), target: 'vendorSettings', permType: aclHelper.isVendorAccount })
    menu.push(...this.commonMenusForExternal())
    return filterMenu(menu)
  },
  showExportContactsByFeature () {
    const featureStatus = getFeatureStatus()
    return featureStatus[FEATURE_NAMES.TENANCY_RECORDS] || featureStatus[FEATURE_NAMES.WORK_PERMITS]
  },
}
